import { FaArrowRight, FaUserEdit } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import AdminSidebarShell from "../components/AdminSidebarShell";

const AdminSettingsPage = () => {
  const navigate = useNavigate();

  return (
    <AdminSidebarShell activeItem="profile">
      <div style={wrap}>
        <div style={header}>
          <h1 style={title}>Settings</h1>
          <p style={subtitle}>Manage your Kin-Keeper account from one place.</p>
        </div>

        <button
          type="button"
          style={settingsCard}
          onClick={() => navigate("/admin/profile/edit")}
        >
          <div style={settingsIcon}>
            <FaUserEdit />
          </div>
          <div style={settingsBody}>
            <h2 style={settingsTitle}>Edit Profile</h2>
            <p style={settingsText}>Open your admin profile and update your details.</p>
          </div>
          <FaArrowRight style={settingsArrow} />
        </button>
      </div>
    </AdminSidebarShell>
  );
};

export default AdminSettingsPage;

const wrap = {
  maxWidth: "900px",
  margin: "0 auto",
  display: "grid",
  gap: "20px"
};

const header = {
  display: "grid",
  gap: "8px"
};

const title = {
  margin: 0,
  color: "#0E5580"
};

const subtitle = {
  margin: 0,
  color: "#64748b",
  fontSize: "15px"
};

const settingsCard = {
  width: "100%",
  background: "#fff",
  border: "1px solid #d9e5ef",
  borderRadius: "16px",
  boxShadow: "0 12px 32px rgba(15,23,42,0.08)",
  padding: "20px 22px",
  display: "flex",
  alignItems: "flex-start",
  gap: "16px",
  textAlign: "left",
  cursor: "pointer"
};

const settingsIcon = {
  width: "52px",
  height: "52px",
  borderRadius: "14px",
  background: "#e8f3fb",
  color: "#0E5580",
  display: "grid",
  placeItems: "center",
  fontSize: "22px",
  flexShrink: 0
};

const settingsBody = {
  flex: 1
};

const settingsTitle = {
  margin: 0,
  color: "#0E5580",
  fontSize: "22px",
  fontWeight: "700"
};

const settingsText = {
  margin: "8px 0 0",
  color: "#64748b",
  fontSize: "14px"
};

const settingsArrow = {
  color: "#94a3b8",
  fontSize: "18px",
  marginTop: "6px",
  flexShrink: 0
};
